/**
 * Base for any API.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class AbstractApi {

}
